import { matchPath } from 'react-router-dom';
import type { DestinationId } from '@/app/config/destinations';
import { ROUTE_DISPOSITIONS } from '@/app/config/route-disposition';

export function destinationCapabilityPath(
  destination: DestinationId,
  capabilityPath: string
): string {
  const prefix = `/${destination}`;
  return capabilityPath === prefix || capabilityPath.startsWith(`${prefix}/`)
    ? capabilityPath
    : `${prefix}${capabilityPath}`;
}

/**
 * Recover the capability identity from a destination-owned URL so role and
 * feature-policy rules can be applied without registering a second route.
 */
export function capabilityPathFromDestination(pathname: string): string | null {
  for (const disposition of ROUTE_DISPOSITIONS) {
    if (disposition.disposition !== 'capability') continue;
    const canonicalPattern = destinationCapabilityPath(
      disposition.destination,
      disposition.originalPath
    );
    if (!matchPath({ path: canonicalPattern, end: true }, pathname)) continue;
    const prefix = `/${disposition.destination}`;
    const capabilityPath = pathname.slice(prefix.length);
    return capabilityPath.startsWith('/') ? capabilityPath : `/${capabilityPath}`;
  }
  return null;
}
